import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@tl4k/frontend-shared';
import { TL4KAppShell } from '@tl4k/admin-ui';
import Dashboard from './components/Dashboard';
import Editor from './components/Editor';
import NotFound from './components/NotFound';

import Player from './components/Player';

function App() {
  return (
    <ThemeProvider ageGroup="7-10">
      <TL4KAppShell appLabel="Magic Page">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/editor/:projectId" element={<Editor />} />
            <Route path="/player/:projectId" element={<Player />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TL4KAppShell>
    </ThemeProvider>
  );
}

export default App;
